'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = MPPHeading;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var levels = [1, 2, 3, 4, 5, 6, '1', '2', '3', '4', '5', '6'];

function MPPHeading(props) {
  var level = props.level,
      rest = _objectWithoutProperties(props, ['level']);

  var LevelComponent = 'h' + level;

  // though children is a required prop, there are cases
  // where no children are passed from organism(missing content)
  // we end up rendering an empty heading with no content.
  if (props.children) {
    return _react2.default.createElement(
      LevelComponent,
      _extends({}, rest, {
        className: (0, _classnames2.default)('pypl-heading', props.className)
      }),
      props.children
    );
  }
  return null;
}

MPPHeading.propTypes = {
  children: _propTypes2.default.node.isRequired,
  level: _propTypes2.default.oneOf(levels),
  className: _propTypes2.default.string
};

MPPHeading.defaultProps = {
  level: '1',
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/atoms/heading/jsx/MPPHeading.js
// module id = 47
// module chunks = 4